/* src/components/library-mgmt/create-update-library-item-modal/create-update-library-item-modal.component.scss */
:host .modal-tab {
  overflow: auto;
  height: 40vh;
}
/*# sourceMappingURL=create-update-library-item-modal.component-F56YS6B2.css.map */
